import { gql } from '@apollo/client'

export const AddMusicReaction = gql`
    mutation AddMusicReaction($roomId: ID!, $trackId: ID!, $reaction: ReactionType!) {
        addMusicReaction(roomId: $roomId, trackId: $trackId, reaction: $reaction) {
            actor {
                id
                username
                avatar
            }
            id
            reaction
            room {
                id
                members {
                    id
                    lastActivity
                    username
                    avatar
                }
            }
            track {
                id
                album
                artist
                bitRate
                codec
                composer
                contributors {
                    id
                    username
                }
                coverArt {
                    full
                    thumb250
                    thumb500
                    thumb1200
                }
                created
                date
                duration
                files {
                    bitRate
                    duration
                    key
                    size
                }
                genre
                roomId
                size
                tags
                title
                track
                updated
                youtubeId
            }
            updated
        }
    }
`

export default AddMusicReaction

